define([
	"csi/action/AggregateBase",
	"csi/def/ActionFactory",
	"csi/xml"
], function(AggregateBase,ActionFactory,xml) {

	return ActionFactory.declare("Aggregate", AggregateBase, {
		constructor: function(obj) {
			this.setBaseRights(xml.RIGHT_WRITE);
		},

		checkNodeAccess: function(node) {
			// summary: make sure the attribute is enabled and editable unless reverse aggregation
			return this._checkAccess(node, this.m_right, this.m_rightBase);
		}
	});
});